function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { PlaybackType } from '../../../../core/player/playout-data';
import { ContentType } from '../../../addon-playout-data';
export { Source } from './conviva-addon-proposition.enums';
export function convertContentType(contentType) {
    switch(contentType){
        case ContentType.Entertainment:
            return 'Entertainment';
        case ContentType.Movies:
            return 'Movies';
        case ContentType.Sports:
            return 'Sports';
        case ContentType.Kids:
            return 'Kids';
        case ContentType.News:
            return 'News';
        default:
            return '';
    }
}
export function adaptMetadata(metadata, playoutData, videoQuality) {
    var _playoutData_assetMetadata;
    var assetId;
    var channelId;
    if (metadata === undefined) {
        metadata = {};
    }
    if (playoutData === null || playoutData === void 0 ? void 0 : (_playoutData_assetMetadata = playoutData.assetMetadata) === null || _playoutData_assetMetadata === void 0 ? void 0 : _playoutData_assetMetadata.assetId) {
        if ([
            PlaybackType.Live,
            PlaybackType.SingleLiveEvent
        ].includes(playoutData.type)) {
            channelId = playoutData.assetMetadata.assetId;
        } else {
            assetId = playoutData.assetMetadata.assetId;
        }
    } else {
        if ('channelId' in metadata) {
            channelId = metadata.channelId;
        }
        if ('id' in metadata) {
            assetId = metadata.id;
        }
    }
    var _metadata_availableAt;
    var availableSince = (_metadata_availableAt = metadata.availableAt) !== null && _metadata_availableAt !== void 0 ? _metadata_availableAt : null;
    var assetUuid;
    if ('id' in metadata) {
        assetUuid = metadata.uuid;
    } else {
        assetUuid = null;
    }
    // PF assumes that assetTitle represents the series title of an episode. Now we have a seriesTitle that we can use instead.
    var assetTitle;
    if (metadata.seriesTitle) {
        assetTitle = metadata.seriesTitle;
    } else if ('title' in metadata) {
        assetTitle = metadata.title;
    }
    // PF requires contentType to be Entertainment or Kids to report episode metadata.
    var contentType;
    if (metadata.contentType) {
        contentType = metadata.contentType;
    } else if (metadata.seriesTitle) {
        contentType = ContentType.Entertainment;
    }
    var _metadata_duration;
    return _object_spread_props(_object_spread({}, metadata), {
        availableSince: availableSince || null,
        videoQuality: videoQuality || '',
        assetId: assetId || '',
        assetUuid: assetUuid || '',
        assetTitle: assetTitle || '',
        channelId: channelId || '',
        contentType: contentType || {},
        metadataDuration: (_metadata_duration = metadata === null || metadata === void 0 ? void 0 : metadata.duration) !== null && _metadata_duration !== void 0 ? _metadata_duration : null
    });
}

//# sourceMappingURL=index.js.map